import { render, staticRenderFns } from "./WaiterDetailTab.vue?vue&type=template&id=565bb1d4&scoped=true&lang=pug"
import script from "./WaiterDetailTab.vue?vue&type=script&lang=ts"
export * from "./WaiterDetailTab.vue?vue&type=script&lang=ts"
import style0 from "./WaiterDetailTab.vue?vue&type=style&index=0&id=565bb1d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565bb1d4",
  null
  
)

export default component.exports